import { render, staticRenderFns } from "./DenunciarFraude.vue?vue&type=template&id=778b6388"
import script from "./DenunciarFraude.vue?vue&type=script&lang=js"
export * from "./DenunciarFraude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports